export const queryString = params => {
  const queryStr = Object.keys(params)
    .map(key => {
      if (Array.isArray(params[key])) {
        return params[key]
          .map(val => `${key}=${encodeURIComponent(val)}`)
          .join("&");
      }
      return `${key}=${encodeURIComponent(params[key])}`;
    })
    .join("&");

  return queryStr;
};
